module.exports={
	"Scope": "Document-List",
	"CoreEntity": "Document",
	"TitleTemplate": "Documents",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "Name",
			"PictDashboard": {}
		},
		"Status":
		{
			"Name": "Status",
			"Hash": "Status",
			"PictDashboard": {}
		},
		"CreatingIDUser":
		{
			"Name": "Created By",
			"Hash": "CreatingIDUser",
			"PictDashboard": {}
		},
		"DocumentDate":
		{
			"Name": "Date",
			"Hash": "DocumentDate",
			"PictDashboard": {
				"ValueTemplate": "{~DateFormatNoFallback:Record.Payload.DocumentDate^MM/DD/YYYY~}"
			}
		},
		"DocumentType":
		{
			"Name": "Type",
			"Hash": "DocumentType",
			"PictDashboard": {
				"ValueTemplate": "{~DocumentTypeName:Record.Payload.DocumentType~}"
			}
		},
		"IDProject":
		{
			"Name": "Project",
			"Hash": "IDProject",
			"PictDashboard": {}
		}
	}
}
